export class VcaAlert {
    public type: string;
    public message: string[];
    public timeout: number;
    public location: string;
    constructor(message: any, type: string, location?: string, timeout?: number) {
        this.type = type;
        this.message = Array.isArray(message) ? message : [message];
        if (timeout) {
            this.timeout = timeout;
        }
        this.location = location ? location : 'main';
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-alerts/vca-alert.ts